import React from 'react';
import App from 'Views/App';

function ClientApp() {
  return <App />;
}

export default ClientApp;
